import React, { Component } from 'react';
import Api from '../../Api';
import WmDropdown from '../../Layout/WmDropdown';
import HtmlHelpers from '../../HtmlHelpers';
export default class BaseApi extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = async () => {
      await this.getOptions(this.props.auth);
    };
    this.getApiName = () => '';
    this.getDropdownLabelText = () => '';
    this.getDropdownFieldName = () => '';
    this.getDropdownOnly = () => false;
    this.getLabelFieldName = () => 'name';
    this.getPlaceholder = () => 'Select...';
    this.getValueFieldName = () => this.props.valueField || 'uuid';
    this.getApiParams = () => [];
    this.getApiVersion = () => 1;
    this.getStyles = () => {};
    this.isSearchable = () => true;
    this.maxMenuHeight = () => 300;
    this.additionalFields = () => [];
    this.getOptions = async auth => {
      let options = [];
      if (!this.props.data) {
        await Api.crudList(auth, this.getApiName(), this.getApiParams(), this.getApiVersion()).then(response => {
          if (response.data !== undefined) {
            const optionList = response.data.map(d => {
              const item = {};
              this.additionalFields().forEach(key => item[key] = d.attributes[key]);
              return {
                label: d.attributes[this.getLabelFieldName()],
                value: d.attributes[this.getValueFieldName()],
                item
              };
            });
            options = this.uniqueArray(optionList);
          }
        });
      }
      this.setState({
        items: options
      });
    };
    this.uniqueArray = a => [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s));
    this.getItemList = () => {
      const info = this.props.data ? this.props.data : this.state.items;
      return info.filter(i => i.value === this.props.currentValue || HtmlHelpers.isEmpty(this.props.used) || !this.props.used.includes(i.value));
    };
    this.getValue = () => {
      let details = this.props.multi ? [] : '';
      this.getItemList().forEach(item => {
        if (this.props.multi && this.props.multiUuidOnly !== true) {
          details = this.props.currentValue;
        } else if (this.props.multi && this.props.currentValue.includes(item.value)) {
          details.push(item);
        } else if (item.value === this.props.currentValue) {
          details = item;
        }
      });
      return details;
    };
    this.state = {
      items: []
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(WmDropdown, {
      text: this.getDropdownLabelText(),
      name: this.getDropdownFieldName(),
      htmlFor: this.getDropdownFieldName(),
      dropdownOnly: this.getDropdownOnly(),
      labelColumns: this.props.labelColumns,
      placeholder: this.getPlaceholder(),
      fieldColumns: this.props.fieldColumns,
      values: this.getValue(),
      options: this.getItemList(),
      onChange: this.props.onChange,
      buttonAfter: this.props.buttonAfter,
      multi: this.props.multi,
      disabled: this.props.disabled,
      maxMenuHeight: this.maxMenuHeight(),
      isRequired: this.props.isRequired || false,
      isSearchable: this.isSearchable(),
      styles: this.getStyles()
    });
  }
}